<!--
 * @Author: cn1994
 * @Date: 2025-04-17 17:36:34
 * @LastEditors: cn1994
 * @LastEditTime: 2025-04-22 10:29:55
 * @Description: file content
-->
<template>
  <div class="wrapper fixed h-full w-full">
    <transition
      mode="out-in"
      enter-active-class="fadeIn"
      leave-active-class="fadeOut"
      appear
    >
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
};
</script>

<!-- <style>
html, body {
  font-family: 'PingFang SC';
}
</style> -->